import React from 'react';

import { MetricValue } from 'src/graphql';

interface MetricCellTierProps {
  value?: MetricValue | null;
}

export const MetricCellTier: React.FC<MetricCellTierProps> = ({ value }) => {
  return (
    <div style={{ height: '100%', display: 'flex', alignItems: 'center', paddingLeft: 8 }}>
      {value?.tier || '-'}
    </div>
  );
};
